import React, { useContext } from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import './App.css';
import Messages from './components/layout/content/Messages.js';
import Home from './components/layout/content/Home.js';
import SignIn from './components/layout/content/SignIn';
import PasswordReset from './components/layout/content/PasswordReset';
import AuthContext from './context/AuthContext';
import BrokenPage from './components/layout/content/BrokenPage';

const theme = {
  primary: '#FF478F',
  maxWidth: '1300px',
};

const AppContainer = styled.div`
  background-color: ${(props) => props.theme.primary};
  overflow: hidden;
`;

const App = () => {
  const { userState } = useContext(AuthContext);

  return (
    <ThemeProvider theme={theme}>
      <AppContainer>
        <Router>
          <Switch>
            <Route path="/messages">
              {userState ? <Messages /> : <SignIn />}
            </Route>
            <Route path="/passwordReset">
              <PasswordReset />
            </Route>
            <Route path="/" exact>
              <Home />
            </Route>
            <Route path="*" exact component={BrokenPage} />
          </Switch>
        </Router>
      </AppContainer>
    </ThemeProvider>
  );
};

export default App;
